/* eslint-disable */
import { React, Component, Fragment } from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
// core components
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardAvatar from "components/Card/CardAvatar.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";

import avatar from "assets/img/faces/marc.jpg";
import Spinner from 'components/Spinner.js';
import moment from "moment";

import RoleList from "./PermissionList";

const styles = {
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
};

const useStyles = makeStyles(styles);

export default function (props) {
  const classes = useStyles();
  return <RoleProfile classes={classes} {...props} />
}

class RoleProfile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newRoleMode: props.role_id == null,
      showSpinner: true,
      showData: false,
      updating: false,
      role_id: props.role_id,
      fields: props.fields || [
            `name`,
            `description`,
            ].reduce((p,c) => {
                p[c] = props[c] || '';
                return p;
            }, {}),
      data: {},
      message: '',
    };
  }

  componentDidMount() {
    if (this.state.newRoleMode)
    {
      this.setState({
        showSpinner: false,
        showData: true
      });
    }
    else
      this.refreshUser();
  }

  refreshUser = () => {
    var $this = this;
    fetch(`/api/shared/roles/lookup/`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify({ role_id: $this.state.role_id })
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        if (data.status.success) {
          var role = data.data.role;
          var fields = {};
          fields.name = role.name;
          fields.description = role.description;

          $this.setState({
            data: role,
            fields: fields,
            showSpinner: false,
            showData: true
          });
        }
        else {
          $this.setState({
            showSpinner: false
          });
          alert('There was an error. Please try again later.')
        }
      }).catch(() => {
        $this.setState({
          showSpinner: false
        });
        alert('There was an error. Please try again later.')
      });
  }

  handleOnChange = (e) => {
    const fields = this.state.fields;
    fields[e.target.name] = e.target.value;
    //const fieldErrors = this.validate(fields)
    this.setState({ fields, 
      //fieldErrors, formValidated: true, showError: null 
    });
  }

  handleUpdate = () => {
    const fields = this.state.fields;
    this.setState({
      updating: true,
    })
    //userId, string email, string last_name, string other_names
    var $this = this;
    fetch(`/api/shared/roles/${$this.state.newRoleMode ? 'new' : 'update'}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: JSON.stringify({ 
        roleId: $this.state.role_id, 
        name: fields.name,
        description: fields.description, 
       })
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        if (data.status.success) {
          var role = data.data.role;
          var fields = {};
          fields.name = role.name;
          fields.description = role.description;

          $this.setState({
            data: role,
            fields: fields,
            showSpinner: false,
            showData: true,
            updating: false,
            message: `Role ${$this.state.newRoleMode ? 'added' : 'updated'}.`,
            role_id: role.id,
            newRoleMode: false,
          });
        }
        else {
          $this.setState({
            showSpinner: false,
            updating: false,
            message: `Error ${$this.state.newRoleMode ? 'adding' : 'updating'} role. Please try again later.`
          });
          //alert('There was an error. Please try again later.')
        }
      }).catch(() => {
        $this.setState({
          showSpinner: false,
          updating: false,
          message: `Error ${$this.state.newRoleMode ? 'adding' : 'updating'} role. Please try again later.`
        });
      });
  }

  render () 
  {
    const classes = this.props.classes;
    return (
      <div>
        { this.state.showSpinner ?
          <Spinner/> 
          : "" 
        }
        { this.state.showData ?
        <GridContainer>
          <GridItem xs={12} sm={12} md={8}>
            <Card>
              <CardHeader color="primary">
                <h4 className={classes.cardTitleWhite}>{this.state.newRoleMode ? 'Add' : 'Update'} Role {this.state.data.username}</h4>
                <p className={classes.cardCategoryWhite}>Complete role details</p>
              </CardHeader>
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText="Name"
                      id="name"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        name: "name",
                        value: this.state.fields.name || '',
                        onChange: this.handleOnChange,
                        //readOnly: !this.state.newUserMode,
                      }}
                    />
                  </GridItem>
                  {/* <GridItem xs={12} sm={12} md={3}>
                    <CustomInput
                      labelText="Last Login"
                      id="last_login"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        name: "last_login",
                        value: moment(this.state.data.last_login).format('YYYY/MM/D HH:mm:ss') || '',
                        readOnly: true,
                      }}
                    />
                  </GridItem> */}
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText="Description"
                      id="description"
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        name: "description",
                        value: this.state.fields.description || '',
                        onChange: this.handleOnChange,
                        readOnly: false,
                      }}
                    />
                  </GridItem>
                </GridContainer>
                {this.state.role_id ?
                  <RoleList role_id={this.state.role_id} />
                : null}
              </CardBody>
              <CardFooter>
                {this.state.updating ?
                <Fragment>
                  <Button color="primary" disabled>{this.state.newRoleMode ? 'Add' : 'Update'} Role</Button>
                  <Spinner/>
                </Fragment>
                :
                <Fragment>
                  <Button color="primary" onClick={this.handleUpdate}>{this.state.newRoleMode ? 'Add' : 'Update'} Role</Button>
                  <span>{this.state.message}</span>
                </Fragment>
                }
              </CardFooter>
            </Card>
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            {/* <Card profile>
              <CardAvatar profile>
                <a href="#pablo" onClick={(e) => e.preventDefault()}>
                  <img src={avatar} alt="..." />
                </a>
              </CardAvatar>
              <CardBody profile>
                <h6 className={classes.cardCategory}>CEO / CO-FOUNDER</h6>
                <h4 className={classes.cardTitle}>Alec Thompson</h4>
                <p className={classes.description}>
                  Don{"'"}t be scared of the truth because we need to restart the
                  human foundation in truth And I love you like Kanye loves Kanye
                  I love Rick Owens’ bed design but the back is...
                </p>
                <Button color="primary" round>
                  Follow
                </Button>
              </CardBody>
            </Card> */}
          </GridItem>
        </GridContainer>
        : null }
      </div>
    );
  }
}
